<div class="skeleton-loader h-full w-full"></div>
